export default () => ( {
    activeMenu : "",
       
    // methods
    toggleMenu( slug ) {
        if( slug == this.activeMenu ) { 
            this.activeMenu = "";
        } else {
            this.activeMenu = slug;
        }
    }
} );